export default "__VITE_ASSET__e862da8e__"